// extracted by mini-css-extract-plugin
export default {"icon":"_1au0M","reversedIcon":"pKzXS","overflow":"_3cXd2","title":"_1D9yc","mobile":"pwXvc","listContentTitleColor":"vtngo"};